<template>
    <div class="flex justify-content-between align-items-center px-4 md:px-7 py-4">
        <div class="w-2/4 flex align-items-start">
            <img v-if="view.value" class="mr-3" width="15px" src="/assets/images/helpers/icon-circle-check.svg" alt="" />
            <div class="inline-block">
                <p class="tx-12 md:tx-14 tx-grey-1 weight-500 mb-1" v-html="prop_title" />
                <p class="tx-10 md:tx-12 tx-lightgrey-1 mb-0" v-html="prop_text" />
            </div>
        </div>
        <div class="w-2/4 break-all flex align-items-start justify-content-end tx-right pl-6">
            <div v-if="view.value" class="flex align-items-start break-all">
                <div>
                    <a :href="view.document" download class="tx-12 md:tx-14 tx-grey-1 weight-500 mb-1" v-html="view.value" />
                    <p class="tx-10 md:tx-12 tx-lightgrey-1 mb-0" v-html="view.size" />
                </div>
                <label v-if="prop_status == 'pending'" v-bind:for="'upload_' + prop_field">
                    <img class="hidden sm:block ml-4" width="20px" :src="'/assets/images/helpers/icon-edit.svg'" alt="">
                    <input class="hidden" :id="'upload_' + prop_field" type="file" @change="uploadFile">
                </label>
            </div>

            <label v-else-if="prop_status == 'pending'" v-bind:for="'upload_' + prop_field">
                <div class="btn btn--white tx-10 smv-bind:tx-12 md:tx-14 tx-black">
                    Seleccionar archivo
                </div>
                <input class="hidden" :id="'upload_' + prop_field" type="file" @change="uploadFile">
            </label>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {

        props: {
            prop_title: {
                type: String,
                default: ''
            },
            prop_text: {
                type: String,
                default: ''
            },
            prop_field: {
                type: String,
                default: ''
            },
            prop_value: {
                type: String,
                default: ''
            },
            prop_size: {
                type: String,
                default: ''
            },
            prop_type: {
                type: String,
                default: ''
            },
            prop_document: {
                type: String,
                default: ''
            },
            prop_status : {
                type: String,
                default: ''
            }
        },
        watch: {
            user(state) {
                let vm = this;
                if ( state.id !== undefined ) {
                    vm.user_id  = state.id;
                }
            }
        },
        data() {
            return {
                item_file: null,
                user_id: null,
                formData: null,
                view: {
                    'document': null,
                    'value': null,
                    'size': null
                },
                err: []
            }
        },

        beforeMount(){
            let vm = this;
            vm.view = {
                'document': vm.prop_document,
                'value':    vm.prop_value,
                'size':     vm.prop_size
            }
        },
        
        computed: { 
            ...mapState(['user'])
        },

        methods: {
            async uploadFile(e) {
                let vm = this;
                vm.item_file = e.target.files[0];
                vm.formData = new FormData();
                vm.err = [];

                vm.formData.append('type', vm.prop_field);
                vm.formData.append('file', vm.item_file);
                let data = null;

                await axios.post('client/users/' + vm.user_id + '/upload_documents', vm.formData)
                .then(response => {
                    data = response.data;
                    vm.$swal({
                        icon: "success",
                        title: "Archivo cargado.",
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        confirmButtonText: 'Aceptar'
                    });
                }).catch(error => {
                    vm.err = error.response.data;
                });

                if( vm.err.message) {
                    vm.$swal({
                        icon: "warning",
                        title: "Error",
                        text: vm.err.message,
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        confirmButtonText: 'Aceptar'
                    });
                }else{
                    vm.view.document    = data.file;
                    vm.view.value       = data.origin_name;
                    vm.view.size        = data.size;
                }

            }
        },

    }
</script>
